<template>
  <section id="hero">
    <v-carousel cycle hide-delimiter-background show-arrows-on-hover>
      <v-carousel-item
        src="@/assets/itsm-maritech.jpg"
        class="white--text image"
        gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
      >
        <v-container class=" px-4 py-12">
          <v-responsive
            class="d-flex align-center"
            height="100%"
            max-width="700"
            width="100%"
          >
            <base-heading title="MariTech ITSM" />

            <p>
              Enjoy the adaptability and extensibility of IT Service Management
              System which is specially developed to suit work flow of the
              Maritime industry.
              <br />
            </p>
            <br /><br />
            <div
              :class="
                $vuetify.breakpoint.smAndDown
                  ? 'flex-column align-start'
                  : 'align-center'
              "
              class="d-flex flex-wrap pt-5"
            >
              <base-btn
                v-bind:to="'/demo' + '/' + routePath + '/kaits'"
                target="_blank"
                color="blue darken-2"
              >
                Book Demo
              </base-btn>
            </div>
          </v-responsive>
        </v-container>
      </v-carousel-item>

      <v-carousel-item
        src="@/assets/slide2.jpg"
        class="white--text image"
        gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
      >
        <v-container class=" px-4 py-12">
          <v-responsive
            class="d-flex align-center"
            height="100%"
            max-width="700"
            width="100%"
          >
            <base-heading
              title="Navigating Your Maritime Success with Cutting-Edge IT Solutions"
            />

            <p>
              Your Trusted Maritime IT Partner Worldwide
              <br />
              Innovative IT Solutions for Maritime Excellence
              <br />
            </p>

            <div
              :class="
                $vuetify.breakpoint.smAndDown
                  ? 'flex-column align-start'
                  : 'align-center'
              "
              class="d-flex flex-wrap pt-5"
            >
              <base-btn
                v-bind:to="'/solutions'"
                target="_blank"
                color="blue darken-2"
              >
                Explore
              </base-btn>
            </div>
          </v-responsive>
        </v-container>
      </v-carousel-item>
    </v-carousel>
  </section>
</template>

<script>
export default {
  name: "SectionHero",

  provide: {
    theme: { isDark: true }
  },
  data() {
    return {
      routePath: "",
      items: [
        {
          src: require("@/assets/banner.jpg")
        },
        {
          src: require("@/assets/solutions5.jpeg")
        }
      ]
    };
  },
  mounted() {
    this.routePath = this.$router.currentRoute.name;
    console.log(this.routePath);
  },
  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";
      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    }
  }
};
</script>
<style scoped>
.displayImage {
  display: none;
}
@media only screen and (max-width: 350px) {
  .displayImage {
    display: inline;
    height: 50%;
  }
  .sliderImage {
    display: none;
  }
  .subHead {
    font-size: 5px;
  }
}
</style>
